import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import QRCode from 'qrcode.react';
import domtoimage from 'dom-to-image-improved';
import {changeDpiDataUrl} from "changedpi/src";
import './QrCodeGenerator.scss';

import qrCodeBgImage from '../assets/images/black_sensor_bg.jpg';

const selector = state => {
    const { language } = state;
    return {
        t: language.translator
    }
};

const QrCodeGeneratorMultiple = () => {
    const { t } = useSelector(selector);
    const [codeData, setCodeData] = useState('');
    const [qrCodeImages, setQrCodeImages] = useState([]);

    const createQrCode = data => <QRCode id='qrCode' value={data} size={180}/>;

    const generateQrCode = data => {
        return createQrCode(data);
    };

    const generateQrCodes = async () => {
        const codesData = JSON.parse(codeData);
        let qrCodesArray = [];

        codesData.forEach(item => {
            qrCodesArray.push({image: generateQrCode(item.scannerCode, item.count), code: item.scannerCode, count: item.count});
        });

        setQrCodeImages(qrCodesArray)
    };

    const downloadQR = index => {
        const node = document.getElementById('qrCodeImageComposition' + index);

        domtoimage.toJpeg(node, {quality: 1})
            .then(dataUrl => {
                const dataUrl300dpi = changeDpiDataUrl(dataUrl, 300);
                let downloadLink = document.createElement('a');
                downloadLink.href = dataUrl300dpi;
                //downloadLink.download = "qrCode.jpg";
                downloadLink.download = document.getElementsByClassName('qrCodeText' + index)[0].innerHTML + "_black.jpg";

                document.body.appendChild(downloadLink);
                downloadLink.click();
                document.body.removeChild(downloadLink);
            })
            .catch(function (error) {
                console.error('Oops, something went wrong!', error);
            });
    };

    return (
        <div className='qrCodeGenerator'>
            <div className='qrCodeGeneratorHeader'>{t.gettext('QR Code Generator Multiple')}</div>
            <div className='qrCodeGeneratorBox'>
                <form className='qrCodeGeneratorForm qrCodeGeneratorForm--large'>
                    <div className='qrCodeGeneratorFormItem qrCodeGeneratorFormItem--large'>
                        <div className='qrCodeGeneratorFormLabel'>
                            {t.gettext('Code data in json')}
                        </div>
                        <textarea
                            className='qrCodeGeneratorFormInput qrCodeGeneratorFormInput--large'
                            onChange={e => setCodeData(e.target.value)}
                        />
                    </div>
                    <div className='generateButtonHolder'>
                        <button
                            className='generateButton'
                            onClick={e => {
                                e.preventDefault();
                                generateQrCodes();
                            }}
                            disabled={!codeData}
                        >
                            {t.gettext('GENERATE')}
                        </button>
                    </div>
                </form>
                {!!qrCodeImages.length &&
                    qrCodeImages.map((image, index) => (
                        <div key={index}>
                            <div
                                id={`qrCodeImageComposition${index}`}
                                className={`qrCodeImageComposition qrCodeImageComposition${index}`}
                                style={{backgroundImage: "url(" + qrCodeBgImage + ")", backgroundSize: 'cover'}}
                            >
                                <div className='qrCodeImageWrapper'>
                                    {image.image}
                                </div>
                                <div className={`qrCodeText qrCodeText${index}`}>{image.count + '-' + image.code}</div>
                            </div>
                            <div className='downloadButtonHolder'>
                                <button
                                    className='downloadButton'
                                    onClick={() => downloadQR(index)}
                                >
                                    {t.gettext('DOWNLOAD')}
                                </button>
                            </div>
                        </div>
                    ))
                }
                {/*{qrCodeImage &&*/}
                {/*    <div className='downloadButtonHolder'>*/}
                {/*        <button*/}
                {/*            className='downloadButton'*/}
                {/*            onClick={downloadQR}*/}
                {/*            disabled={!scannerCode || !count}*/}
                {/*        >*/}
                {/*            {t.gettext('DOWNLOAD')}*/}
                {/*        </button>*/}
                {/*    </div>*/}
                {/*}*/}
            </div>
        </div>
    );
};

export default QrCodeGeneratorMultiple;
